import {HttpEvent, HttpHandlerFn, HttpInterceptorFn, HttpRequest} from '@angular/common/http';
import {Observable} from 'rxjs';
import {EmployeeService} from '../service/employee.service';
import {inject} from '@angular/core';
import {ApiAuthenticateResponseModel} from '../model/api-authenticate-response.model';

/**
 * @constant
 * @description This constant provides an interceptor to handle employee API authentication JWT injection into HTTP requests.
 * @export
 * @interceptor
 * @name EmployeeApiAuthenticationInterceptorFn
 * @param {HttpRequest<any>} httpRequest The HTTP request to intercept.
 * @param {HttpHandlerFn} next The next handler in the chain.
 * @returns {Observable<HttpEvent<any>>} The observable of the HTTP event.
 */
export const EmployeeApiAuthenticationInterceptorFn: HttpInterceptorFn = (httpRequest: HttpRequest<any>, next: HttpHandlerFn): Observable<HttpEvent<any>> => {

  // Ensure we're not working with an administrator route, if so execute the next handler in the chain.
  if (!httpRequest.url.match(/^(https?:\/\/.*)?\/api\/employee\/?.*?$/gis)) return next(httpRequest);

  // Ensure we need credentials, if not execute the next handler in the chain.
  if (!httpRequest.withCredentials) return next(httpRequest);

  // Localize our employee service.
  const employeeService: EmployeeService = inject(EmployeeService);

  // Retrieve the session token from the session storage.
  const session: ApiAuthenticateResponseModel = employeeService.ensureSession();

  // Reset the request object to include the session token.
  const newHttpRequest: HttpRequest<any> = httpRequest.clone({setHeaders: {Authorization: `Bearer ${session.token}`}});

  // We're done, execute the next handler in the chain.
  return next(newHttpRequest);
};
